import React, { useState, useEffect } from "react";
import {
  AIRTABLE_APIKEY,
  AIRTABLE_BASE,
  SHOPIFY_DOMAIN,
  SHOPIFY_TOKEN,
} from "./config";
import { demoStack } from "./components/defaults";
import uniqid from "uniqid";
import { useToasts } from "react-toast-notifications";
import Client from "shopify-buy";

const Airtable = require("airtable");

const client = Client.buildClient({
  storefrontAccessToken: SHOPIFY_TOKEN,
  domain: SHOPIFY_DOMAIN,
});

Airtable.configure({
  endpointUrl: "https://api.airtable.com",
  apiKey: AIRTABLE_APIKEY,
});
const base = Airtable.base(AIRTABLE_BASE);

const MetaContext = React.createContext();

function MetaProvider({ children }) {
  const { addToast } = useToasts();

  const [locale, setLocale] = useState("en");

  const [supplements, setSupplements] = useState([]);
  const [categories, setCategories] = useState([]);
  const [goal, setGoal] = useState([]);

  const [actStack, setActStack] = useState("stack0");

  const [stacks, setStacks] = useState();

  const [quizes, setQuizes] = useState([]);
  const [quizAnswers, setQuizAnswers] = useState([]);

  const [isCartOpen, setCartOpen] = useState();

  const [checkout, setCheckout] = useState({ lineItems: [] });
  const [products, setProducts] = useState();
  const [shop, setShop] = useState();

  useEffect(() => {
    client.checkout.create().then((res) => {
      console.log("CHECKOUT = ", res);
      setCheckout(res);
    });
  }, []);

  useEffect(() => {
    client.product.fetchAll(100).then((res) => {
      console.log("res = ", res.length);
      setProducts(res);
    });
  }, []);

  useEffect(() => {
    client.shop.fetchInfo().then((res) => {
      console.log("SHOP = ", res);
      setShop(res);
    });
  }, []);

  const addVariantToCart = (variantId, quantity) => {
    setCartOpen(true);

    const lineItemsToAdd = [{ variantId, quantity: parseInt(quantity, 10) }];
    const checkoutId = checkout.id;

    return client.checkout
      .addLineItems(checkoutId, lineItemsToAdd)
      .then((res) => {
        setCheckout(res);
      });
  };

  const addArrayToCart = (lineItemsToAdd) => {
    // setCartOpen(true)
    const checkoutId = checkout.id;
    return client.checkout
      .addLineItems(checkoutId, lineItemsToAdd)
      .then((res) => {
        setCheckout(res);
        window.open(checkout.webUrl, "_self");
      });
  };

  const updateQuantityInCart = (lineItemId, quantity) => {
    const checkoutId = checkout.id;
    const lineItemsToUpdate = [
      { id: lineItemId, quantity: parseInt(quantity, 10) },
    ];

    return client.checkout
      .updateLineItems(checkoutId, lineItemsToUpdate)
      .then((res) => {
        setCheckout(res);
      });
  };

  const removeLineItemInCart = (lineItemId) => {
    const checkoutId = checkout.id;
    return client.checkout
      .removeLineItems(checkoutId, [lineItemId])
      .then((res) => {
        setCheckout(res);
      });
  };
  const handleCartClose = () => {
    setCartOpen(false);
  };

  useEffect(() => {
    if (stacks) {
      console.log("saveToLocal = ", saveToLocal);
      saveToLocal();
    }
  }, [stacks]);

  useEffect(() => {
    if (!supplements.length) {
      base("All Supplements")
        .select({
          maxRecords: 100,
        })
        .eachPage(
          function page(records, fetchNextPage) {
            setSupplements([
              ...supplements,
              ...records
                .filter((record) => record.get("Active"))
                .map((record) => ({
                  id: record["id"],
                  name: record.get("Name"),
                  code: record.get("Code"),
                  ppu: record.get("PPU") ? record.get("PPU") : 0,
                  usage: record.get("Usage"),
                  dosage: record.get("Dosage"),
                  categories: record.get("Categories")
                    ? record.get("Categories")
                    : [],
                  goal: record.get("Core") ? record.get("Core") : [],
                  secondary: record.get("Secondary Topic")
                    ? record.get("Secondary Topic")
                    : [],
                  image: record.get("Image"),
                  color: record.get("Color"),
                  when: record.get("When")[0],
                })),
            ]);
            // records.forEach(function(record) {
            //   console.log('Retrieved', record.get('Categories'));
            // });
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [supplements]);

  useEffect(() => {
    if (!categories.length) {
      base("Categories")
        .select({
          maxRecords: 100,
          sort: [{ field: "Importance", direction: "desc" }],
        })
        .eachPage(
          function page(records, fetchNextPage) {
            setCategories([
              ...categories,
              ...records
                .filter((record) => record.get("Active"))
                .map((record) => ({
                  id: record.id,
                  name: record.get("Name"),
                  title: record.get("Title"),
                  description: record.get("Description"),
                })),
            ]);
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [categories]);

  useEffect(() => {
    if (!quizes.length) {
      base("Quizes")
        .select({
          maxRecords: 100,
        })
        .eachPage(
          function page(records, fetchNextPage) {
            setQuizes([
              ...quizes,
              ...records
                .filter((record) => record.get("Active"))
                .map((record) => ({
                  id: record.id,
                  code: record.get("Code"),
                  title: record.get("Title"),
                  questions: record.get("Questions").map((oneQ) => ({
                    id: oneQ,
                  })),
                })),
            ]);
            // fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [quizes]);

  useEffect(() => {
    if (quizes.length && !quizAnswers.length) {
      base("Quiz answers")
        .select({
          maxRecords: 100,
        })
        .eachPage(
          function page(records, fetchNextPage) {
            setQuizAnswers([
              ...quizAnswers,
              ...records
                .filter((record) => record.get("Active"))
                .map((record) => ({
                  id: record.id,
                  quizes: record.get("Quizes"),
                  code: record.get("Code"),
                  q_en: record.get("q_en"),
                  q_ru: record.get("q_ru"),
                  a1_en: record.get("a1_en"),
                  a2_en: record.get("a2_en"),
                  a3_en: record.get("a3_en"),
                  a4_en: record.get("a4_en"),
                  a1_ru: record.get("a1_ru"),
                  a2_ru: record.get("a2_ru"),
                  a3_ru: record.get("a3_ru"),
                  a4_ru: record.get("a4_ru"),
                  a1_sups: record.get("a1_sups"),
                  a2_sups: record.get("a2_sups"),
                  a3_sups: record.get("a3_sups"),
                  a4_sups: record.get("a4_sups"),
                })),
            ]);
            // fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [quizes, quizAnswers]);

  useEffect(() => {
    if (!goal.length) {
      base("Topics")
        .select({
          maxRecords: 100,
          sort: [{ field: "Importance", direction: "desc" }],
        })
        .eachPage(
          function page(records, fetchNextPage) {
            setGoal([
              ...goal,
              ...records
                .filter((record) => record.get("Active"))
                .map((record) => ({
                  id: record.id,
                  name: record.get("Name"),
                  title: record.get("Title"),
                  description: record.get("Description"),
                  core: record.get("Core") ? record.get("Core") : [],
                  secondary: record.get("Other options")
                    ? record.get("Other options")
                    : [],
                })),
            ]);
            fetchNextPage();
          },
          function done(err) {
            if (err) {
              console.error(err);
              return;
            }
          }
        );
    }
  }, [goal]);

  // useEffect(() => {
  //   debugger
  //   if (stacks[Object.keys(stacks)[0]]) {
  //     saveToLocal()
  //   }
  // }, [stacks])

  const addToStack = (items) => {
    console.log("items = ", items);
    // setStack([...new Set([...getStack(), ...items])]);
    setStack([...getStack(), ...items]);
  };

  const handleStack = (id) => {
    if (getStack().filter((one) => one["id"] === id).length) {
      setStack([
        ...new Set([...getStack().filter((item) => item["id"] !== id)]),
      ]);
    } else {
      let data = supplements.filter((oneSup) => oneSup["id"] === id)[0];

      setStack([
        ...getStack(),
        {
          id: id,
          addedWhen: Date.now(),
          useWhen: data ? data["when"] : "anytime",
        },
      ]);
    }
  };

  const checkIfInStack = (id) => {
    let a = getStack().filter((item) => item["id"] === id)[0];
    return a ? true : false;
  };

  useEffect(() => {
    if (!stacks && supplements.length && categories.length && goal.length) {
      if (getFromLocal()) {
        setActStack(getFromLocal()["activeStack"]);
        setStacks(getFromLocal()["stacks"]);
      } else {
        // setStack(demoStack)
        setStacks({
          stack0: {
            id: "stack0",
            title: "My first stack",
            user: 0,
            stack: [],
          },
        });
      }
    }
  }, [supplements, categories, goal, stacks]);

  const getStack = (what = "stack") => {
    if (!stacks) return [];
    if (what) return stacks[actStack][what];
    if (!what) return stacks[actStack];
  };

  const getStackInfo = (stackId = actStack) => {
    if (stacks) return stacks[stackId];
  };

  const setStack = (newData, stackId = actStack) => {
    let oldData = JSON.parse(JSON.stringify(stacks));
    oldData[stackId]["stack"] = newData;
    setStacks(oldData);
  };

  const deleteStack = (stackId = actStack) => {
    if (Object.keys(stacks).length === 1) {
      setStack([]);
      return;
    }
    let oldData = JSON.parse(JSON.stringify(stacks));
    delete oldData[stackId];
    setActStack(Object.keys(oldData)[0]);
    setStacks(oldData);
    addToast("Deleted Successfully", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 1000,
    });
  };

  const shareStack = (url) => {
    addToast(
      <>
        Copy this link <input type="text" value={`${url}`} />
      </>,
      { appearance: "success" }
    );
  };

  const createStack = (
    newStackData = {
      id: "",
      title: "New stack",
      stack: [],
    },
    switchToNew = true
  ) => {
    let oldData = JSON.parse(JSON.stringify(stacks));
    // let title = newStackData["title"].split(" ")[0];

    // let newId = `${title.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')}_${uniqid.time()}`;
    let newId = `imported_${uniqid.time()}`;

    oldData[newId] = newStackData;
    oldData[newId]["id"] = newId;
    // oldData[newId]['title'] = `Copy of ${oldData[newId]['title']}`;
    setStacks(oldData);
    if (switchToNew) setActStack(newId);
    addToast("Stack created Successfully", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 1000,
    });

    // saveToLocal()
  };

  const duplicateStack = (id = actStack, switchToNew = true) => {
    let oldData = JSON.parse(JSON.stringify(stacks));
    let newId = `${oldData[id]["id"]}_${uniqid.time()}`;
    oldData[newId] = JSON.parse(JSON.stringify(oldData[id]));
    oldData[newId]["id"] = newId;
    oldData[newId]["title"] = `Copy of ${oldData[newId]["title"]}`;
    setStacks(oldData);
    if (switchToNew) setActStack(newId);
    addToast("Duplicated Successfully", {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 1000,
    });
  };

  const saveStackName = (newName, id = actStack) => {
    let oldData = JSON.parse(JSON.stringify(stacks));
    oldData[id]["title"] = newName;
    setStacks(oldData);
  };

  const switchActiveStack = (id) => {
    setActStack(id);
    // saveToLocal()
  };

  const getAllStacks = (asObject = false) => {
    if (!stacks) return [];
    if (asObject) return stacks;
    return Object.keys(stacks).map((one) => stacks[one]);
  };

  const getQuizes = () => {
    return quizes;
  }

  const getQuiz = (quizCode, what = "qa") => {
    let qs = [];

    let quiz = quizes.filter((item) => item["code"] === quizCode)[0];

    if (!quiz || !quizAnswers.length) return [];

    quiz["questions"].forEach((oneQid) => {
      let q = quizAnswers.filter((oneQ) => oneQ["id"] === oneQid["id"])[0];
      qs.push(q);
    });

    // let qId = quizes.filter((item) => item["code"] === quizCode)[0];
    // let q = qId && quizAnswers.length ? quizAnswers.filter(oneQ => oneQ['quizes'].includes(qId['id'])) : [];
    return what === "qa" ? qs : quiz;
  };

  const saveToLocal = (alert) => {
    let data = JSON.stringify({
      activeStack: actStack,
      stacks: stacks,
    });
    // .replace('value:false,', 'defaultValue:false,')
    // .replace('value:true,', 'defaultValue:true,');
    localStorage.setItem("meta", data);
    if (alert)
      addToast("Saved Successfully", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 1000,
      });
  };

  const getFromLocal = () => {
    let data = localStorage.getItem("meta");
    // debugger
    return Boolean(data) ? JSON.parse(data) : null;
  };

  return (
    <MetaContext.Provider
      value={{
        state: {
          isCartOpen,
          checkout,
          locale,
        },
        data: {
          client,
          products,
          shop,
          supplements,
          categories,
          goal,
        },
        handles: {
          addToStack,
          checkIfInStack,
          handleStack,
          getStack,
          setStack,
          getStackInfo,
          switchActiveStack,
          getAllStacks,
          createStack,
          duplicateStack,
          deleteStack,
          shareStack,
          saveStackName,
          setCartOpen,
          addVariantToCart,
          updateQuantityInCart,
          removeLineItemInCart,
          handleCartClose,
          addArrayToCart,
          getQuizes,
          getQuiz,
        },
      }}
    >
      {children}
    </MetaContext.Provider>
  );
}

const MetaConsumer = MetaContext.Consumer;

export { MetaContext, MetaProvider, MetaConsumer };
